import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExternaluserredirectionComponent } from './externaluserredirection/externaluserredirection.component';
import { LoginComponent } from './login';
import { ChangepasswordComponent } from './user/changepassword/changepassword.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'iadvl' },
  { path: 'iadvl', component: LoginComponent },
  { path: 'iadvl/changepassword', component: ChangepasswordComponent },
  { path: 'iadvl/submit/abstract/external', component: ExternaluserredirectionComponent },
  { path: 'iadvl/register', loadChildren: () => import('./register/register.module').then( (m) => m.RegisterModule) },
  { path: 'iadvl/application', loadChildren: () => import('./user/abstract/abstract.module').then( (m) => m.AbstractSubmissionModule) },
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
